import getCompanies from "../../../../infrastructure/common/repositories/getCompanies";

const findCompanies = getCompanies;

export default findCompanies;
